"use es6";

import { addDomEvent } from "./add-dom-event";
import { addPointerInfo } from "./event-info";
function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, eventName, addPointerInfo(handler), options);
}
export { addPointerEvent };